/* eslint-disable sonarjs/no-duplicate-string */
const ruDictionary = {
  translation: {
    Найти: 'Найти',
    'ГСЖ начало': 'ГСЖ начало',
    'ГСЖ окончание': 'ГСЖ окончание',
    'ГСЖ дни': 'ГСЖ дни',
    ГСЖ: 'Укажите гарантированный срок жизни товара. Он должен составлять не менее 2/3 срока хранения после получения товара.',
    Логин: 'Логин',
    'Восстановление пароля':
      'Пожалуйста, введите Ваш логин. Мы вышлем Вам ссылку для восстановления пароля на привязанный к логину email.',
    'Ваш логин': 'Ваш логин',
    'Ссылка устарела': 'Ссылка устарела. Пожалуйста, запросите новую ссылку для восстановления пароля.',
    Пароль: 'Пароль',
    Войти: 'Войти',
    Офферы: 'Офферы',
    Торги: 'Торги',
    Поставщик: 'Поставщик',
    'RVI Менеджер': 'RVI Менеджер',
    'КМ ТС Менеджер': 'КМ ТС Менеджер',
    Финанализ: 'Финанализ',
    Товары: 'Товары',
    'Текущая торговая неделя': 'Текущая торговая неделя',
    Поиск: 'Поиск',
    Заказчик: 'Заказчик',
    Финкод: 'Финкод',
    Активен: 'Активен',
    Неактивен: 'Неактивен',
    УИ4: 'УИ4',
    PLU: 'PLU',
    'Товар (RU)': 'Товар (RU)',
    'Товар (EN)': 'Товар (EN)',
    Калибр: 'Калибр',
    Квант: 'Квант',
    'Количество офферов': 'Количество офферов',
    'Общий объем': 'Общий объем',
    Статус: 'Статус',
    Штрихкод: 'Штрихкод',
    неизвестно: 'неизвестно',
    'не назначена': 'не назначена',
    'нет данных': 'нет данных',
    'Новый оффер': 'Новый оффер',
    Оффер: 'Оффер',
    'Первая цена': 'Первая цена',
    'Цена от RVI': 'Цена от RVI',
    'Утверждённая цена': 'Утверждённая цена',
    'Предложение цены - за кг/шт': 'Предложение цены - за кг/шт',
    'Создать оффер': 'Создать оффер',
    'Страна отправления': 'Страна отправления',
    'Страна происхождения': 'Страна происхождения',
    'Регион отправления': 'Регион отправления',
    'Способ доставки': 'Способ доставки',
    'Условия поставки': 'Условия поставки',
    'Условия поставки INCOTERMS': 'Условия поставки INCOTERMS',
    Сорт: 'Сорт',
    Класс: 'Класс',
    'Предлагаемый объем (шт/кг)': 'Предлагаемый объем (шт/кг)',
    'Вес нетто (машина/контейнер)': 'Вес нетто (машина/контейнер)',
    'Вес брутто (машина/контейнер)': 'Вес брутто (машина/контейнер)',
    'Неделя отгрузки ПЛАН': 'Неделя отгрузки ПЛАН',
    'Неделя прихода в порт ПЛАН': 'Неделя прихода в порт/свх ПЛАН',
    'Неделя прихода ХАБ/РЦ': 'Неделя прихода ХАБ/РЦ',
    'Дата отгрузки': 'Дата отгрузки',
    'Дата прихода в порт/свх': 'Дата прихода в порт/свх',
    'Дата прихода РЦ/ХАБ': 'Дата прихода РЦ/ХАБ',
    'Кол-во коробок': 'Кол-во коробок/мешков на машину/контейнер',
    'Кол-во паллет на машину/контейнер': 'Кол-во паллет на машину/контейнер',
    'Коробок на паллете': 'Коробок на паллете',
    'Кол-во контейнеров/машин': 'Кол-во контейнеров/машин',
    'Материал упаковки': 'Материал упаковки',
    'Тип укладки': 'Тип укладки',
    'Город ХАБ/РЦ': 'Город ХАБ/РЦ',
    Город: 'Город',
    Объем: 'Объем',
    'Таможенный пункт входа': 'Таможенный пункт входа',
    Комментарии: 'Комментарии',
    Отправить: 'Отправить',
    'текст сообщения': 'текст сообщения',
    Нет: 'Нет',
    'Доставка на ХАБ/РЦ': 'Доставка на ХАБ/РЦ',
    'Точка доставки': 'Точка доставки',
    'Дата прихода на ХАБ/РЦ': 'Дата прихода на ХАБ/РЦ',
    Объём: 'Объём',
    Объем_full_name: 'Объём',
    'Цена на РЦ': 'Цена на РЦ',
    Валюта: 'Валюта',
    Себестоимость: 'Себестоимость',
    'Себестоимость (руб)': 'Себестоимость (руб.)',
    'Вы вошли как': 'Вы вошли как',
    'Оффер создан': 'Оффер создан',
    'Оффер обновлен': 'Оффер обновлён',
    'Комментарий отправлен': 'Комментарий отправлен',
    Сохранить: 'Сохранить',
    Ответить: 'Ответить',
    size: '🏷 Калибр',
    selected_size_russian_title: '🏷 Калибр',
    status: 'Статус',
    status_ok: '✅ Согласован',
    status_waiting: '❌ Отклонен',
    status_decline: '🕙 На согласовании',
    quantum: '🏷 Квант',
    variety: '🍏 Сорт',
    selected_variety_russian_title: '🍏 Сорт',

    unit: 'Ед. измерения',

    currency: '💰 Валюта',
    hub_price: '💰 Цена на хаб',
    rvi_price: '💰 Цена от rvi',
    net_weight: '🚛 Вес нетто (машина/контейнер)',
    boxes_count: 'Кол-во коробок',
    first_price: '💰 Цена',
    gross_weight: '🚛 Вес брутто (машина/контейнер)',
    freight_price: '💰 Стоимость фрахта',
    pallets_count: 'Кол-во паллет на машину/контейнер',
    product_class: '🏷 Класс',
    delivery_terms: '🚚 Условия поставки',
    offered_volume: '📦 Предлагаемый объем (шт/кг) ',
    packaging_type: 'Тип укладки',
    refusal_reason: 'Причина отказа',
    supplier_price: '💰 Цена от поставщика',
    shipping_terms: 'ПРР',
    transport_mode: '🚚 Способ доставки',
    rc_moscow_price: '💰 Цена на хаб (Москва)',
    transport_count: 'Кол-во контейнеров/машин',
    expected_units_quantity: 'Кол-во контейнеров/машин',
    packing_material: 'Материал упаковки',
    origin_country: '🌏 Страна происхождения',
    exporting_region: '🌏 Регион отправления',
    exporting_country: '🌏 Страна отправления',
    customs_entry_point: 'Точка входа',
    entry_city_of_arrival: 'Город Хаб/РЦ',
    submitted_delivery_point: 'ХАБ/РЦ',
    freight_lilo_conditions: 'lilo',
    port_eta_planned_week: 'Неделя прихода в порт',
    port_eta_planned: 'Дата прихода в порт',
    dc_eta_planned_week: 'Неделя прихода РЦ/ХАБ',
    dc_eta_planned: 'Дата прихода РЦ/ХАб',
    etd_planned: 'Дата отгрузки',
    etd_planned_week: 'Неделя отгрузки',
    volume: 'Объём',
    price: 'Цена',
    week_planned: 'Неделя прихода на ХАБ/РЦ',
    'Высокая цена': 'Высокая цена',
    'Превышает потребность': 'Превышает потребность',
    'Не соответствует стандартам': 'Не соответствует стандартам',
    'Закрыта карточка': 'Закрыта карточка',
    'Не устраивает логистика': 'Не устраивает логистика',
    Активность: 'Активность',
    'Изменения по офферу': 'Изменения по офферу',
    'Изменил(а) параметр': 'Изменил(а) параметр',
    'Предыдущее значение': 'Предыдущее значение',
    'Новое значение': 'Новое значение',
    'Добавил(а)': 'Добавил(а)',
    'Создал оффер': 'Создал оффер',
    'Добавил(а) комментарий': 'Добавил(а) комментарий',
    'Курс валюты': 'Курс валюты',
    'Параметры товара': 'Параметры товара',
    Доставка: 'Доставка',
    Упаковка: 'Упаковка',
    Даты: 'Даты',
    'Стоимость фрахта': 'Стоимость фрахта',
    Trading: 'Торгуется',
    'Approved for order': 'Согласован',
    'Waiting for approval': 'На согласовании',
    Refused: 'Отклонён',
    'Selected for approval': 'Торгуется',
    'Укажите стоимость 1 ед. товара': 'Укажите стоимость 1 ед. товара',
    'Укажите общий (в кг/шт) предлагаемый объём товара (не кол-во транспортных единиц)':
      'Укажите общий (в кг/шт) предлагаемый объём товара (не кол-во транспортных единиц)',
    'Укажите цены на те точки, на которые Вы готовы везти предлагаемый объём':
      'Укажите цены на те точки, на которые Вы готовы везти предлагаемый объём',
    'Событий (3+) еще': 'Событий: (3+) еще',
    preorder: 'Предзаказ',
    created: 'Новый',
    creating_failed: 'Ошибка при создании',
    cancelled: 'Отменен',
    'Доступный объем': 'Доступный объем',
    'обязательное поле': 'Обязательное поле',
    price_by_unit: 'Цена за единицу',
    Expired: 'Истёк',
    False: 'нет',
    True: 'есть',
    null: 'пусто',
    pcs: 'шт',
    kg: 'кг',
    l: 'л',
    'Вы уверены?': 'Вы уверены?',
    Да: 'Да',
    Отмена: 'Отмена',
    Действия: 'Действия',
    Шаблоны: 'Шаблоны',
    'Применить шаблон': 'применить шаблон',
    Закрыть: 'Закрыть',
    Новый: 'Новый',
    'Шаблонов к данному продукту пока нет': 'Шаблонов к данному продукту пока нет',
    Название: 'Название',
    'Сохранить шаблон': 'Сохранить шаблон',
    'Создать шаблон': 'Создать шаблон',
    'Номер недели': 'Номер недели',
    Категория: 'Категория',
    'ID оффера': 'ID оффера',
    'ID микса': 'ID микса',
    'Товар (RUS)': 'Товар (RUS)',
    'Товар (ENG)': 'Товар (ENG)',
    Баркод: 'Баркод',
    'Кол-во коробок/мешков на машину/контейнер': 'Кол-во коробок/мешков на машину/контейнер',
    'Предложенный объем': 'Предложенный объем',
    Единица: 'Единица',
    'Цена за единицу': 'Цена за единицу',
    Курс: 'Курс',
    'Неделя погрузки ПЛАН': 'Неделя погрузки ПЛАН',
    'Неделя прихода в порт (план)': 'Неделя прихода в порт (план)',
    'Дата погрузки': 'Дата погрузки',
    'Дата прихода в порт': 'Дата прихода в порт',
    'Причина отказа': 'Причина отказа',
    'Есть комментарии': 'Есть комментарии',
    'High price': 'Высокая цена',
    'Exceeds demand': 'Превышает потребность',
    'Out of standard': 'Не соответствует стандартам',
    'Demand is covered': 'Закрыта карточка',
    'Logistics does not suit': 'Не устраивает логистика',
    'Сбросить фильтры': 'Сбросить фильтры',
    'Ваша учётная запись была деактивирована. Обратитесь к менеджерам X5.':
      'Ваша учётная запись была деактивирована. Обратитесь к менеджерам X5.',
    'Вес брутто': 'Вес брутто',
    'Вес нетто': 'Вес нетто',
    Восстановить: 'Восстановить',
    'Забыли пароль?': 'Забыли пароль?',
    'Неправильный логин или пароль!': 'Неправильный логин или пароль!',
    Изменения: 'Изменения',
    Истёк: 'Истёк',
    Комментарий: 'Комментарий',
    'Мин значение': 'Мин. значение',
    'Макс значение': 'Макс. значение',
    'На согласовании': 'На согласовании',
    'Нашли ошибку? Eсть предложения по улучшению? Напишите нам':
      'Нашли ошибку? Eсть предложения по улучшению? Напишите нам',
    'Неделя прихода на ХАБ/РЦ ПЛАН': 'Неделя прихода на ХАБ/РЦ ПЛАН',
    Неделя: 'Нед.',
    'Валюта офера': 'Валюта офера',
    'Новый пароль': 'Новый пароль',
    Отклонен: 'Отклонен',
    'Пароль должен содержать не меньше 8 символов, включая латинские буквы, цифры и знаки препинания.':
      'Пароль должен содержать не меньше 8 символов, включая латинские буквы, цифры и знаки препинания.',
    'Повторите пароль': 'Повторите пароль',
    Согласован: 'Согласован',
    Торгуется: 'Торгуется',
    'Укажите стоимость 1 ед товара': 'Укажите стоимость 1 ед товара',
    экспорт: 'экспорт',
    'Всего строк': 'Всего строк',
    'Показывать по': 'Показывать по',
    'Цена КА Поставщик': 'Моя цена',
    'Цена КА': 'Цена КА',
    passwordErrWide: 'Введённый пароль слишком широко распространён.',
    passwordErrShort: 'Введённый пароль слишком короткий. Он должен содержать как минимум 8 символов.',
    passwordErrDigitsOnly: 'Введённый пароль состоит только из цифр.',
    passwordErrWordsOnly: 'Пароль должен содержать цифры и буквы. Попробуйте еще раз.',
    passwordNameEqual: 'Введённый пароль слишком похож на имя.',
    passwordLoginEqual: 'Введённый пароль слишком похож на имя пользователя.',
    passwordLastNameEqual: 'Введённый пароль слишком похож на фамилию.',
    passwordEmailEqual: 'Введённый пароль слишком похож на email.',
    user_is_inactive:
      'Ваша учетная запись деактивирована. Дополнительную информацию Вы можете уточнить у Вашего менеджера.',
    resetting_password_denied: 'Активная учетная запись отсутствует. Обратитесь к Вашему менеджеру.',
    resetting_password_empty: 'Это поле не может быть пустым.',
    'Ожидает запуска': 'Ожидает запуска',
    'W ETD Filter': 'W ETD',
    'W ETA Filter': 'W ETA',
    'W ETA DC Filter': 'W ETA DC',
    'ETD Filter': 'ETD',
    'ETA PORT Filter': 'ETA PORT',
    'ETA DC Filter': 'ETA DC',
    'Загрузка..': 'Загрузка..',
    'Timings does not suit': 'Не устраивают тайминги',
    'ГСЖ дни тултип':
      'Укажите гарантированный срок жизни товара в днях. Он должен составлять не менее 2/3 срока хранения после получения товара. Срок жизни товара начинает считаться автоматически с даты отгрузки.',
    Нед: 'Нед.',
    январь: 'январь',
    февраль: 'февраль',
    март: 'март',
    апрель: 'апрель',
    май: 'май',
    июнь: 'июнь',
    июль: 'июль',
    август: 'август',
    сентябрь: 'сентябрь',
    октябрь: 'октябрь',
    ноябрь: 'ноябрь',
    декабрь: 'декабрь',
    'Ст проис': 'Ст. проис.',
    'Ст отпр': 'Ст. отпр.',
    'ХАБ/РЦ p': 'ХАБ/РЦ p.',
    'РЦ МСК p': 'РЦ МСК p.',
    'Начало гарантированного срока жизни товара':
      'Начало гарантированного срока жизни товара. Должен составлять не менее 2/3 срока хранения товара после его получения.',
    'Конец гарантированного срока жизни товара':
      'Конец гарантированного срока жизни товара. Должен составлять не менее 2/3 срока хранения товара после его получения.',
    approved_by_tn: 'Согласовано ТС к старту',
    approved_by_tn_to_run: 'Согласовано ТС к запуску',
    not_approved_by_tn_to_run: 'Не согласовано ТС к запуску',
    not_approved_by_tn: 'Не согласовано ТС к старту',
    on_approval: 'На согласовании',
    auction_going_on: 'Идет аукцион',
    auction_completed: 'Аукцион завершен',
    new: 'Новая',
    finished: 'Завершена',
    running: 'Выполняется',
    Отменена: 'Отменена',
    paused: 'Остановлена',
    'Выберите параметры для разных условий поставки': 'Выберите параметры для разных условий поставки:',
    product_plu: 'PLU',
    product_is_busi: 'Признак УСИ/БУСИ',
    offered_volume_from: 'Предлагаемый объем, oт',
    offered_volume_to: 'Предлагаемый объем, до',
    net_weight_from: 'Вес нетто, от',
    net_weight_to: 'Вес нетто, до',
    gross_weight_from: 'Вес брутто, от',
    gross_weight_to: 'Вес брутто, до',
    shelf_life_days_from: 'ГСЖ дни, от',
    shelf_life_days_to: 'ГСЖ дни, до',
    price_by_unit_from: 'Цена Поставщика, от',
    price_by_unit_to: 'Цена Поставщика, до',
    price_on_delivery_point_from: 'Себестоимость Поставщика, от',
    price_on_delivery_point_to: 'Себестоимость Поставщика, до',
    boxes_count_from: 'Кол-во коробок/мешков на машину/контейнер , от',
    boxes_count_to: 'Кол-во коробок/мешков на машину/контейнер , до',
    pallets_count_from: 'Кол-во паллет на машину/контейнер, от',
    pallets_count_to: 'Кол-во паллет на машину/контейнер, до',
    boxes_per_pallet_from: 'Коробок на паллете, от',
    boxes_per_pallet_to: 'Коробок на паллете, до',
    transport_count_from: 'Кол-во контейнеров/машин, от',
    transport_count_to: 'Кол-во контейнеров/машин, до',
    etd_planned_from: 'Дата отгрузки, от',
    etd_planned_to: 'Дата отгрузки, до',
    port_eta_planned_from: 'Дата прихода в порт/свх, от',
    port_eta_planned_to: 'Дата прихода в порт/свх, до',
    dc_eta_planned_from: 'Дата прихода РЦ/ХАБ, от',
    dc_eta_planned_to: 'Дата прихода РЦ/ХАБ, до',
    auction_stage_progress1_tooltip: '*Общий предложенный объём vs. общий требуемый объём в программе',
    auction_stage_progress2_tooltip:
      '*Общий предложенный объём соответствующий таргет ценам vs. общий требуемый объём в программе',
    auction_stage_circlebar1_tooltip:
      '*Поставщики подавшие хотя бы одно предложение vs. общее кол-во поставщиков в этапе',
    auction_stage_circlebar2_tooltip: '*Кол-во предложений достигших таргет цены vs. общее кол-во поданных предложений',
    cancelAuctionDescription:
      'Отмена аукциона приведёт к отмене всех предложений во всех этапах аукциона. Поставщики участники получат уведомление об этом. Все предложения будут помечены как отменённые.',
    compeleteAuctionDescription:
      'Досрочное завершение аукциона приведёт к тому, что все запланированные, но ещё не начатые этапы аукциона будут отменены. \n\n Поставщики получат уведомления с текущими результатами аукциона. \n\n Программа сформируется из того набора предложений, которые были собраны в текущем состоянии аукциона.',
    restartAuctionStageDescription:
      'Вы уверены, что хотите возобновить этап? Запуск этапа отправит поставщикам участникам e-mail уведомление. Все оферы участников будут переведены в статус «на рассмотрении».',
    tooltipCreateTemplate:
      'Вы можете создать шаблон оффера для многократного применения. Заполните те поля, которые сохранятся в шаблоне.  Отредактировать шаблон можно будет в любое время.',
    descriptionModalDeleteTemplateOffer: 'Все параметры шаблона будут удалены безвозвратно.',
    поиск: 'поиск...',
    'Ordered volume': 'Объем',
    'Deleted by supplier': 'Удален',
    Cancelled: 'Отменен',
    Paused: 'Остановлен',
    Допинформация: 'Доп.информация',
    supplier_name: 'Поставщик',
    product_ui4: 'УИ4',
    'Ваша цена автоматически приравняется цене Import': 'Ваша цена автоматически приравняется цене Import.',
    supplier_auction_template_text: 'Выберите параметры для разных условий поставки:',
    nonfrov_coming_kmts:
      'Вы зарегистрированы в системе как КМ ТС. Мы уже работаем над новым функционалом, скоро он появится здесь.',
    nonfrov_coming_rvi:
      'Вы зарегистрированы в системе как КМ RVI. Мы уже работаем над новым функционалом, скоро он появится здесь.',
    nonfrov_coming_supplier:
      'Вы зарегистрированы в системе как Поставщик. Мы уже работаем над новым функционалом, скоро он появится здесь.',
    no_data_found: 'По вашему запросу ничего не найдено. Попробуйте ввести другие данные',
    ТС_tn: 'ТС',
    collection: 'Сбор офферов',
    selection: 'Выбор офферов',
    finish: 'На согласовании ТС',
    rejected: 'Проект отклонен',
    projects_not_found_message: 'По вашему запросу ничего не найдено. Попробуйте ввести другие данные',
    Едизм: 'Ед. изм.',
    'Ед изм': 'Ед. изм.',
    Финкод2: 'Финкод',
    Сеть2: 'Сеть',
    'Выбор страны': 'Выберите из списка',
    'Выбор региона': 'Выберите из списка',
    'Мин цена поставщика': 'Мин. цена поставщика',
    New: 'Новый',
    'Under review': 'На рассмотрении',
    'Sent to TN': 'Отправлен в сеть',
    'Refused by RVI': 'Отклонен RVI',
    'Оффер предварительно выбран менеджером Редактирование невозможно':
      'Оффер предварительно выбран менеджером. Редактирование невозможно',
    'Запрашиваемая страница не найдена':
      'Запрашиваемая страница не найдена. Возможно, страница была удалена, перенесена в другое место или при вводе адреса была допущена ошибка.',
    loadingClickCancel: 'Загрузка. Нажмите чтобы отменить',
    photoProductMax10mb: 'Фото продукции (макс 10 мб.)',
    excelMax10mb: 'Файл Excel (макс 10 мб.)',
    pdfMax10mb: 'Файл pdf (макс 10 мб.)',
    'Rejected by TN': 'Отклонен ТС',
    'Agreed by TN': 'Согласован ТС',
    'Способ доставки нефров': 'Способ доставки',
    'На шт руб': 'На шт.руб',
    Подтвердить2: 'Подтвердить',
    'Подтвердить удаление?': 'Изменить выбор будет нельзя. Подтвердить удаление?',
    with_ts: 'С ТЗ',
    without_ts: 'Без ТЗ',
    strategy: 'Ассортиментная стратегия',
    theFileIsTooLarge: 'Файл слишком большой. Выберите файл меньше 10Мб',
    'Preference the ad valorem rate': 'Преферен. адвалорная ставка, %',
    'Preference specific rate': 'Преферен. специфическая ставка, %',
    unitPcsInOneBox: 'Кол-во товара в коробке',
    'Вместимость коробок Алко': 'Вместимость коробок',
    on_approval_rvi: 'На согласовании RVI',
    under_revision: 'В обработке ТС',
    formation: 'Формирование КП',
    on_approval_tn: 'КП на согласовании КМ ТС',
    agreed: 'Согласовано КМ ТС',
    degustation: 'Дегустация',
    certification: 'Сертификация',
    registration_of_contract: 'Оформление договора',
    order_registration: 'Оформление заказа',
    'Регулярные потребности': 'Рег. потребности',
    demand_product_ts: 'Файл ТЗ',
    demand_product_presentation: 'Презентация',
    demand_product_picture: 'Фото',
    demand_product_other: 'Другое',
    ocp_excel_file_calculator: 'Файл Калькулятор',
    own_trademark: 'СТМ',
    total_demand: 'Общая потребность',
    local_demand: 'Потребность ХАБ/РЦ',
    is_busi_True: 'БУСИ',
    is_busi_False: 'УСИ',
    regular_demands_not_found_message: 'По вашему запросу ничего не найдено. Попробуйте ввести другие данные',
    'Ед измерения': 'Ед. измерения',
    'Ошибка Квант':
      'Ошибка при заполнении поля. Квант должен быть целым числом для штучного товара и дробным для весового товара',
    kap_text: 'КА p.',
    product_unit: 'Ед измерения',

    import_volume_from: 'Объем RVI, от',
    import_volume_to: 'Объем RVI, до',

    ca_volume_from: 'Объем KA, от',
    ca_volume_to: 'Объем KA, до',

    ca_transport_count_from: 'Кол-во контейнеров/машин, от',
    ca_transport_count_to: 'Кол-во контейнеров/машин, до',

    import_transport_count_from: 'Кол-во контейнеров/машин RVI, от',
    import_transport_count_to: 'Кол-во контейнеров/машин RVI, до',

    transport_volume: 'Объем (машина/контейнер) кг/шт',
    transport_volume_from: 'Объем (машина/контейнер) кг/шт, от',
    transport_volume_to: 'Объем (машина/контейнер) кг/шт, до',

    tooltipRviSuOrder: 'Кол-во контейнеров/машин',
    'Уважаемые партнёры, портал закрыт. Новая система доступна по адресу importx5.ru':
      'Уважаемые партнёры, портал закрыт. Новая система доступна по адресу <0>importx5.ru</0>. По текущей ссылке в ближайшем будущем будет открываться новая система. Спасибо, что были с нами!',

    // OTP
    'Введите код из письма': 'Введите код из письма',
    'Код отправлен на email': 'Код отправлен на email',
    '6-значный код': '6-значный код',
    'Введите 6 цифр': 'Введите 6 цифр',
    'Код действителен': 'Код действителен',
    'Время действия кода истекло': 'Время действия кода истекло',
    'Проверка...': 'Проверка...',
    Подтвердить: 'Подтвердить',
    'Назад к логину': 'Назад к логину',
    'Пожалуйста, вернитесь на страницу входа и повторите попытку':
      'Пожалуйста, вернитесь на страницу входа и повторите попытку',
    'Код неверный или устарел': 'Код неверный или устарел',
  },
};

export default ruDictionary;
